module.exports = __webpack_public_path__ + "img/logo-ascenti-mobile.91a1f5b6.svg";